import { render, staticRenderFns } from "./wh8footer.vue?vue&type=template&id=1473b4d9&"
import script from "./wh8footer.vue?vue&type=script&lang=js&"
export * from "./wh8footer.vue?vue&type=script&lang=js&"
import style0 from "./wh8footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports